import { jsx, jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { showConfirmationDialog, TgSelect } from "@teselagen/ui";
import "./Ladder.css";
import { Button, Tooltip } from "@blueprintjs/core";
import { showDialog } from "../GlobalDialogUtils";
import { AddLaddersDialog } from "./AddLaddersDialog";
import { ladderDefaults } from "./ladderDefaults";
import useLadders from "../utils/useLadders";
import { map } from "lodash-es";
import { filter } from "lodash-es";
export default function Ladder({
  // gelDigestEnzymes = [],
  boxHeight = 550,
  lanes = [],
  digestLaneRightClicked,
  selectedFragment,
  ladders = ladderDefaults
}) {
  const [additionalLadders, setLadders] = useLadders();
  const laddersToUse = [
    ...ladders,
    ...map(additionalLadders, (l, i) => ({
      ...l,
      label: /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%"
          },
          children: [
            l.label,
            " ",
            /* @__PURE__ */ jsx(
              Button,
              {
                onClick: async (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const confirm = await showConfirmationDialog({
                    text: "Are you sure you want to delete this custom ladder? You cannot undo this action",
                    intent: "danger",
                    confirmButtonText: "Delete",
                    cancelButtonText: "Cancel",
                    canEscapeKeyCancel: true
                  });
                  if (!confirm) {
                    return;
                  }
                  setSelectedLadder(ladders[0].value);
                  setLadders(
                    filter(additionalLadders, (lad) => lad.value !== l.value)
                  );
                },
                intent: "danger",
                small: true,
                minimal: true,
                icon: "trash"
              }
            )
          ]
        },
        i
      )
    }))
  ];
  const [highlightedFragment, setHighlightedFragment] = useState();
  const [selectedLadder, setSelectedLadder] = useState(ladders[0].value);
  let ladderInfo;
  laddersToUse.forEach((ladder) => {
    if (ladder.value === selectedLadder)
      ladderInfo = {
        ...ladder,
        markings: ladder.markings.sort((a, b) => {
          return b - a;
        })
      };
  });
  if (!ladderInfo) {
    return console.error("Uh oh there needs to be ladder info here!");
  }
  const sharedStyle = { color: "white", background: "black" };
  const upperBoundary = ladderInfo.markings[0];
  return /* @__PURE__ */ jsxs("div", { children: [
    "Ladder:",
    /* @__PURE__ */ jsxs("div", { style: { display: "flex" }, children: [
      /* @__PURE__ */ jsx(
        TgSelect,
        {
          className: "tg-ladder-selector",
          value: selectedLadder,
          onChange: (val) => setSelectedLadder(val.value),
          options: laddersToUse
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => {
            showDialog({
              ModalComponent: AddLaddersDialog,
              props: {
                setSelectedLadder
              }
            });
          },
          style: { minWidth: 150 },
          minimal: true,
          small: true,
          icon: "plus",
          intent: "primary",
          children: "Add Ladder"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("br", {}),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "ve-digest-outer-container",
        style: {
          position: "relative",
          width: "fit-content",
          ...sharedStyle
        },
        children: [
          navigator.clipboard && window.isSecureContext && /* @__PURE__ */ jsx(
            Button,
            {
              icon: "duplicate",
              minimal: true,
              style: { position: "absolute", top: 5, right: 5, color: "white" },
              onClick: async () => {
                try {
                  const canvas = await import("html2canvas");
                  canvas.default(document.querySelector(".ve-digest-container")).then((canvas2) => {
                    canvas2.toBlob(
                      (blob) => navigator.clipboard.write([
                        new window.ClipboardItem({ "image/png": blob })
                      ])
                    );
                    window.toastr.success("Image copied to clipboard!");
                  });
                } catch (e) {
                  window.toastr.error(
                    "Error copying the image, try just taking a screenshot instead ;)"
                  );
                }
              }
            }
          ),
          /* @__PURE__ */ jsxs("div", { style: { padding: 3, paddingLeft: 7, width: 290 }, children: [
            "Highlighted Fragment:",
            " ",
            highlightedFragment ? highlightedFragment.size : "--",
            " "
          ] }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: { height: boxHeight, ...sharedStyle },
              className: "ve-digest-container",
              children: [
                /* @__PURE__ */ jsxs(
                  "div",
                  {
                    style: { width: 100 },
                    className: "ve-digest-column ve-digest-ladder",
                    children: [
                      /* @__PURE__ */ jsx("div", { className: "ve-digest-header", children: " " }),
                      ladderInfo.markings.map((val, index) => {
                        return /* @__PURE__ */ jsxs(
                          "div",
                          {
                            style: {
                              fontSize: 12,
                              position: "absolute",
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              color: "white",
                              bottom: calculateOffset(boxHeight, val, upperBoundary) - 3
                              //subtract 3 to get the labels to align better
                            },
                            children: [
                              /* @__PURE__ */ jsxs(
                                "span",
                                {
                                  style: {
                                    color: "white",
                                    paddingLeft: 6,
                                    paddingRight: 4
                                  },
                                  children: [
                                    val,
                                    " "
                                  ]
                                }
                              ),
                              /* @__PURE__ */ jsx("span", { style: { color: "white", paddingRight: 4 }, children: " bp " })
                            ]
                          },
                          index
                        );
                      })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: "ve-digest-column ve-digest-ladder", children: [
                  /* @__PURE__ */ jsx("div", { className: "ve-digest-header", children: "Ladder " }),
                  ladderInfo.markings.map((val, index) => {
                    return /* @__PURE__ */ jsx(
                      "div",
                      {
                        style: {
                          fontSize: 12,
                          position: "absolute",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          color: "white",
                          height: "2px",
                          background: "white",
                          bottom: calculateOffset(boxHeight, val, upperBoundary)
                        }
                      },
                      index
                    );
                  })
                ] }),
                lanes.map((fragments, index) => {
                  return /* @__PURE__ */ jsx(
                    Lane,
                    {
                      ...{
                        onMouseOver: (fragment) => setHighlightedFragment(fragment),
                        onMouseOut: () => setHighlightedFragment(void 0),
                        digestLaneRightClicked,
                        laneNumber: index + 1,
                        fragments,
                        highlightedFragment,
                        selectedFragment,
                        boxHeight,
                        upperBoundary
                      }
                    },
                    index
                  );
                })
              ]
            }
          )
        ]
      }
    )
  ] });
}
function Lane({
  laneNumber,
  onMouseOver,
  onMouseOut,
  digestLaneRightClicked,
  fragments,
  highlightedFragment,
  selectedFragment,
  boxHeight,
  upperBoundary
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: { marginLeft: 20, marginRight: 20 },
      className: "ve-digest-column ve-digest-lane",
      children: [
        /* @__PURE__ */ jsxs("div", { className: "ve-digest-header", children: [
          "Lane ",
          laneNumber,
          " "
        ] }),
        fragments.map((fragment, index) => {
          const { size, id, name } = fragment;
          const isHighlighted = highlightedFragment && id === highlightedFragment.id || selectedFragment && id === highlightedFragment.id;
          return /* @__PURE__ */ jsx(
            "div",
            {
              onMouseOver: () => {
                onMouseOver(fragment);
              },
              onMouseOut: () => {
                onMouseOut(fragment);
              },
              onClick: () => {
                fragment.onFragmentSelect();
              },
              onContextMenu: (e) => {
                fragment.onFragmentSelect();
                digestLaneRightClicked(e);
              },
              "data-test": name,
              style: {
                fontSize: 12,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                color: isHighlighted ? "#fdffdd" : "white",
                width: "90%",
                height: isHighlighted ? "3px" : "2px",
                background: "white",
                bottom: calculateOffset(boxHeight, size, upperBoundary)
              },
              children: /* @__PURE__ */ jsx(
                Tooltip,
                {
                  className: "ve-digest-fragment-tooltip",
                  content: /* @__PURE__ */ jsx("div", { children: name }),
                  children: /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        width: "100%",
                        height: isHighlighted ? "3px" : "2px"
                      }
                    }
                  )
                }
              )
            },
            index
          );
        })
      ]
    }
  );
}
function calculateOffset(boxHeight, size, upperBoundary) {
  return boxHeight * Math.log(size) / Math.log(upperBoundary) - 55;
}
